"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(content) {
  return content.replace(/^```(.+)\s/gm, '```{$1}').split(/^```/gm).map(function (str) {
    return str.trim();
  }).filter(function (str) {
    return str;
  });
};

exports["default"] = _default;